var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"perguntas-frequentes"},[_c('v-card',{staticClass:"py-4 px-2 auth-content",attrs:{"tile":""}},[_c('PageTitle',{attrs:{"main":"TcWeb","icon":"mdi-pencil-box-outline","sub":"Perguntas frequêntes","home":"/home"}}),_c('page-cad')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }